module.exports = __webpack_public_path__ + "media/33.61c586db.wav";